import axiosInstance from "./axiosInstance";

const endpoint = "/agencytest";

// List agency names
export const listAgency = async () => {
  try {
    const response = await axiosInstance.get(`${endpoint}/list_agency`);
    return response.data;
  } catch (error) {
    console.error("Error fetching agency list", error);
    throw error;
  }
};

// Create a new agency
export const createAgency = async (agencyData) => {
  try {
    const response = await axiosInstance.post(`${endpoint}`, agencyData);
    return response.data;
  } catch (error) {
    console.error("Error creating agency:", error);
    throw error;
  }
};

// fetch agency details by id
export const fetchAgencyById = async (id) => {
  try {
    const response = await axiosInstance.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching agency detials", error);
    throw error;
  }
};

// Update an existing agency
export const updateAgency = async (id, agencyData) => {
  try {
    const response = await axiosInstance.put(`${endpoint}/${id}`, agencyData);
    return response.data;
  } catch (error) {
    console.error("Error updating agency:", error);
    throw error;
  }
};

// Delete agency
export const deleteAgency = async (id) => {
  try {
    const response = await axiosInstance.delete(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting agency:", error);
    throw error;
  }
};
